import { render, staticRenderFns } from "./considered.vue?vue&type=template&id=112995d5&"
import script from "./considered.vue?vue&type=script&lang=js&"
export * from "./considered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports